import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./global.css";

// Some older content pages point at images that no longer exist on the server;
// hide those instead of showing a broken-image icon.
document.addEventListener(
  "error",
  (event) => {
    const el = event.target;
    if (el && el.tagName === "IMG" && !el.dataset.keepBroken) {
      const figure = el.closest("figure");
      (figure || el).style.display = "none";
    }
  },
  true
);

createRoot(document.getElementById("root")).render(<App />);
